<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Central de Downloads
      </p>
    </div>
    <tabela></tabela>
  </q-page>
</template>

<script>
import Tabela from "../components/TableDownloads.vue";
export default {
  components: {
    Tabela,
  },
  setup() {
    return {};
  },
};
</script>
